<mulo-centered-block-layout width="full">
    <mulo-side-main-layout #leftColumn [sideColumnSize]="media.is('lt-md') ? 'auto' : '18em'" class="side-column">
        <div class="side-column-content" slot="layout-side">
            @if (profileService.isPublicPage && prevUrl) {
                <a (click)="goBack()" (muloMultipleEvents)="goBack()" class="has-icon back-button" mat-button>
                    <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-left"></mat-icon>
                    {{ 'research.general.back' | translate }}
                </a>
            }

            <exl-person-box>
                <div class="profile-pic-wrap">
                    @if (signedIn && !profileService.isPublicPage) {
                        <button (click)="goToSettings()" class="edit-profile-btn has-icon" mat-raised-button>
                            <mat-icon muloSvgViewbox svgIcon="pencil"></mat-icon>
                            <span>{{ 'research.profile.edit' | translate }}</span>
                        </button>
                    }

                    <mulo-avatar
                        [image]="profileImage"
                        [position]="{ x: 0, y: 20 }"
                        [radius]="6"
                        [size]="media.is('lt-md') ? (media.is('xs') ? '90' : '120') : '200'"
                        [description]="'research.alt.profile.img.with.name' | translate: { value: researcherName }"
                    >
                    </mulo-avatar>
                </div>

                <div class="profile-summary">
                    <h1
                        #title
                        class="margin-bottom-zero is-breaking-words"
                        [ngClass]="{ 'margin-bottom-xs': media.is('xs') }"
                    >
                        <span>{{ profileDataService.displayName.value }}</span>
                    </h1>
                    @if (profileDataService.additionalName.value) {
                        <h2
                                class="additional-name is-breaking-words"
                                [ngClass]="{ 'margin-bottom-xs': media.is('xs') }"
                        >
                            <span>{{ profileDataService.additionalName.value }}</span>
                        </h2>
                    }
                    <ng-container>
                        <h2
                            class="subtitle is-breaking-words"
                            [ngClass]="{ 'margin-bottom-xs margin-top-xs': media.is('xs') }"
                        >
                            @if (profileDataService.displayTitle?.value) {
                                <span>{{ this.profileDataService.displayTitle?.value }}</span>
                            } @else {
                                @if (
                                    showTitleOrPosition(
                                        profileDataService.affiliation?.value,
                                        profileDataService.position?.value
                                    )
                                ) {
                                    <span>{{
                                        affiliationService.getAffTitleOrPositionOrResearcherPosition(
                                            this.profileDataService.affiliation.value,
                                            profileDataService.position.value
                                        ) + ', '
                                    }}</span>
                                }
                                @if (profileDataService.affiliationAncestors?.value.length > 0) {
                                    @for (
                                        affiliation of profileDataService.affiliationAncestors?.value;
                                        track affiliation;
                                        let last = $last
                                    ) {
                                        <span>{{
                                            (affiliation.organizationCode | translate) + (last ? '' : ', ')
                                        }}</span>
                                    }
                                }
                                @if (isDataLoaded && profileDataService.affiliationAncestors?.value.length === 0) {
                                    <span>{{ mainInstCode | translate }}</span>
                                }
                            }
                        </h2>
                    </ng-container>
                    @if (!profileService.isPublicPage && enableCV) {
                        <div class="margin-bottom-sm">
                            <button class="has-icon" mat-raised-button queryParamsHandling="preserve" routerLink="cv">
                                <mat-icon class="mat-icon-rtl-mirror" svgIcon="file-export-outline"></mat-icon>
                                <span>{{ 'esploro.research.cv.page.title' | translate }}</span>
                            </button>
                        </div>
                    }

                    @if (profileDataService.topics.value && profileDataService.topics.value.length > 0) {
                        <exl-expandable-text
                            [buttonInline]="false"
                            [visibleLines]="media.is('xs') ? 1 : 6"
                            blurColor="#fafafa"
                            buttonLabel="{{
                                'research.profile.topics.show.more'
                                    | translate
                                        : {
                                              value: profileDataService.topics.value.length,
                                          }
                            }}"
                        >
                            <exl-tags>
                                @for (tag of profileDataService.topics.value; track tag; let isLast = $last) {
                                    <exl-tag
                                        [label]="tag | defaultTranslate: { default: tag }"
                                        class="hyphens"
                                    ></exl-tag>
                                    @if (!isLast) {
                                        <mulo-separator></mulo-separator>
                                    }
                                }
                            </exl-tags>
                        </exl-expandable-text>
                    }
                </div>
            </exl-person-box>
        </div>

        <div [style.height]="'100%'" ngStyle.lt-md="min-height: 33vh" slot="layout-main">
            <mulo-nav-main-layout
                [navBehavior]="'sticky'"
                [stickyOffset]="0"
                [stickyZIndex]="2"
                class="margin-top-sm"
                navPosition="top"
            >
                <div slot="nav">
                    <nav
                        [mat-stretch-tabs]="false"
                        [tabPanel]="tabPanel"
                        [attr.aria-label]="'research.settings.section.profile' | translate"
                        color="primary"
                        mat-tab-nav-bar
                    >
                        @for (section of profileService.sections; let i = $index; track section) {
                            <a
                                #rla="routerLinkActive"
                                (click)="updateSelectedIndex(i)"
                                (isActiveChange)="handleActive(i, $event)"
                                [active]="rla.isActive"
                                [disabled]="rla.isActive"
                                [queryParams]="{ institution: institutionCode }"
                                [replaceUrl]="true"
                                [routerLink]="section"
                                [attr.aria-label]="
                                    ('research.aria.profile.navigation' | translate) +
                                    ' ' +
                                    ('research.profile.section.' + section | translate)
                                "
                                mat-tab-link
                                routerLinkActive="active"
                            >
                                <span>{{ 'research.profile.section.' + section | translate }}</span>
                            </a>
                        }
                    </nav>
                </div>
                <div [style.height]="'100%'" class="padding-top-sm" slot="main">
                    <div
                        [@tabsChildrenHorizontalAnimation]="{
                            value: selectedIndex,
                            params: { pixels: tabDirection },
                        }"
                        [style.height]="'100%'"
                    >
                        <router-outlet></router-outlet>
                        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
                    </div>
                </div>
            </mulo-nav-main-layout>
        </div>
    </mulo-side-main-layout>
</mulo-centered-block-layout>
